
<template>
  <div>
    <div class="text item">
      <el-form
        ref="form"
        :model="form"
        label-width="200px"
        style="width: 90%"
        :rules="rules"
      >
      <el-form-item label="账户主体" prop="merchant_id"  v-if="this.$route.query && this.$route.query.id != undefined">
          <el-tag>
            {{ merchant }}
          </el-tag>
        </el-form-item>
        <el-form-item
          label="账户主体"
          prop="merchant_id"
         v-else
        >
          <el-select
            v-model="form.merchant_id"
            filterable
            remote
            reserve-keyword
            placeholder="账户主体请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业对公账户" >
          <el-input
            placeholder="企业对公账户"
            v-model="form.account_no"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户银行名称" prop="parent_bank_name">
          <el-input
            placeholder="开户银行名称"
            v-model="form.parent_bank_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行支行名称" prop="bank_name">
          <el-input
            placeholder="开户行支行名称"
            v-model="form.bank_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付行号/银行卡号" prop="union_bank">
          <el-input
            placeholder="支付行号，12位数字"
            v-model="form.union_bank"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行所在地" prop="regions_id">
          <el-cascader
            clearable
            v-model="form.regions_id"
            :options="regions"
            @change="handleRegionChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="开户行地区代码">
          <el-input
            placeholder="开户行地区代码（非必填）"
            v-model="form.bank_city_no"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否禁用" prop="disabled">
          <el-radio
            v-model="form.disabled"
            :label="item.value"
            v-for="(item, index) in disabledArr"
            :key="index"
            >{{ item.name }}</el-radio
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="goBack('form')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import district from "../../../common/district.json";
import {
  getMerchants,
  addMerchantCompanyAccount,
  getMerchantCompanyAccount,
  editMerchantCompanyAccount,
} from "../../../api/merchant";
// 取选中地区的值
function getCascaderObj(val, opt) {
  return val.map(function (value, index, array) {
    for (var itm of opt) {
      if (itm.value === value) {
        opt = itm.children;
        return itm;
      }
    }
    return null;
  });
}

export default {
  data() {
    return {
      merchantList: [],
      merchant: "",
      disabledArr: [
        { name: "否", value: 0 },
        { name: "是", value: 1 },
      ],
      form: {
        disabled: 0,
        merchant_id: "",
        account_no: "",
        parent_bank_name: "",
        bank_name: "",
        union_bank: "",
        bank_city_no: "",
        regions_id: "",
        province: "",
        city: "",
        area: "",
      },
      loading: false,
      regions: district,
      rules: {
        account_no: {
          required: true,
          message: "企业对公账户!",
          trigger: "blur",
        },
        parent_bank_name: {
          required: true,
          message: "开户银行名称!",
          trigger: "blur",
        },
        bank_name: {
          required: true,
          message: "开户行支行名称!",
          trigger: "blur",
        },
        union_bank: [
          {
            required: true,
            message: "支付行号，12位数字!",
            trigger: "blur",
          },
          { min: 12, max: 12, message: "支付行号，12位数字!", trigger: "blur" },
        ],
        province: {
          required: true,
          message: "开户行所在地区!",
          trigger: "blur",
        },
        disabled: {
          required: true,
          message: "是否禁用",
          trigger: "blur",
        },
      },
      dataList: [],
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  components: { draggable },
  methods: {
    handleRegionChange: function (value) {
      var vals = getCascaderObj(value, this.regions);
      if (vals[0] != undefined) {
        this.form.province = vals[0].label;
        this.form.city = vals[1].label;
        this.form.area = vals[2].label;
        console.log(vals, this.form.regions_id);
      }
    },
    goBack() {
      this.$confirm("此操作返回上一个页面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          history.back(0);
        })
        .catch(() => {});
    },
    //编辑显示数据
    getRow(id) {
      getMerchantCompanyAccount({ id: id }).then((res) => {
        this.form = res.data.data.list[0];
        this.getMerchants({ merchant_id: this.form.merchant_id }, 0);
      });
    },
    onSubmit(formName) {
      console.log(this.form);
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }

      var that = this;
      if (this.$route.query.id) {
        editMerchantCompanyAccount(this.$route.query.id, this.form).then(
          (res) => {
            if (res.status) {
              this.loading = false;
              this.$message({
                message: "修改成功",
                type: "success",
                duration: 2000,
              });
              setTimeout(function () {
                that.$router.go(-1);
              }, 2000);
            } else {
              this.$message.error("修改失败!");
              return false;
            }
          }
        );
      } else {
        addMerchantCompanyAccount(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 2000);
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
    getMerchants(query, iserach = 1) {
      var params;
      if (iserach) {
        params = { name: query, is_search: iserach };
      } else {
        params = query;
      }
      getMerchants(params).then((res) => {
        if (iserach == 0) {
          this.merchant = res.data.data.list[0].name;
        } else {
          this.merchantList = res.data.data;
        }
      });
    },
    remoteMethod(query) {
      console.log(query);
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getMerchants(query);
          console.log(this.form.merchant_id);
        }, 200);
      }
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.id != undefined) {
      this.getRow(this.$route.query.id);
    }
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// edit.vue?3e331884